import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const StyledLogoWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 0;
  column-gap: 8px;
  position: relative;
  overflow: hidden;
  width: 100%;
  align-items: center;

  .global-header-logo {
    overflow: unset;
    &-img {
      height: 32px;
      min-width: 100%;
    }
  }

  .mtdls-divider-vertical {
    margin: 0;
    height: 14px;
    top: unset;
  }
`;

const AnchorTagCss = css`
  align-items: center;
  display: flex;
  justify-content: center;
  overflow: hidden;
  text-decoration: none;
`;

export const StyledAnchorTag = styled.a`
  ${AnchorTagCss}
`;

export const StyledLinkTag = styled(Link)<any>`
  ${AnchorTagCss}
`;
